import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appCapitalizeFirst]',
    standalone: true
})
export class CapitalizeFirstDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if (value.length > 0) {
      input.value = this.capitalizeWords(value);
    }
  }

  private capitalizeWords(value: string): string {
    return value
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
}